import { Box, CircularProgress } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import { RouteErrorBoundary } from 'components/route-errors';
import { ContentLoader } from 'components/route-loaders';
import type { JSX } from 'react';
import { lazy, Suspense } from 'react';

const Unsubscribe = lazy(() => import('pages/unsubscribe'));

const Loader = (): JSX.Element => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
    <CircularProgress />
  </Box>
);

export const Route = createFileRoute('/_authenticated/_empty/unsubscribe')({
  pendingComponent: () => <ContentLoader minHeight="50vh" />,
  errorComponent: RouteErrorBoundary,
  component: UnsubscribeWrapper,
});

function UnsubscribeWrapper(): JSX.Element {
  return (
    <Suspense fallback={<Loader />}>
      <Unsubscribe />
    </Suspense>
  );
}
